import { useOAuthCallback } from '@features/auth'
import { LoadingScreen } from '@shared/ui/loading-screen'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/oauth/callback')({
  component: OAuthCallbackPage,
  ssr: false,
})

function OAuthCallbackPage() {
  useOAuthCallback()

  return <LoadingScreen />
}
